module.exports = __webpack_public_path__ + "media/images/lb/628-8fbf5af7527a99faa08c1349df998e15.svg";